import type { TOA } from '@setplex/tria-api'

import { formatTokens, replaceTokens } from '~/entities/announcements'

export const formatToa = (toa: TOA | null) => {
  if (!toa) return null

  const { tokens, message, subject } = toa

  if (tokens) {
    const formattedTokens = formatTokens(tokens)
    return {
      ...toa,
      message: replaceTokens(message, formattedTokens),
      subject: replaceTokens(subject, formattedTokens),
    }
  }
  return toa
}
